import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0 
 *
 **/
const ModalOrderDetailAction = {
    /**
     * 获取单个出库详情
     * @param data
     */
    postDeliveryListInfo(data={}) {
        return request({
            url: '/service/mg/delivery-management/delivery-list-info',
            method: "POST",
            data
        });
    },
};

export default ModalOrderDetailAction;
